import React from "react";
import SharedInputText from "../../components/Shared/SharedInputText";
import SharedPasswordField from "../../components/Shared/SharedPasswordField";
import { Formik, Form } from "formik";
import * as yup from "yup";
import { FaLock, FaRegUser } from "react-icons/fa";
import SharedButton from "../../components/Shared/SharedButton";
import { useDispatch, useSelector } from "react-redux";
import { SignIn } from "../../store/slices/AuthSlice";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { WHerToLogin } from "../../layouts/RootLayout/Navbar";
import Spinner from "../../components/Shared/Spinner";
import LangSwitcher from "../../components/Shared/LangSwitcher";
import { CurrentVersion } from "../../config";
import LoginForm from "./LoginForm";

export default function Login() {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const initialValues = {
    employee_id: "",
    password: "",
  };

  const validationSchema = yup.object().shape({
    password: yup.string().required(t("password_is_required")),
    employee_id: yup.string().required(t("username_is_required")),
  });

  const { isLoading } = useSelector((state) => state.auth);

  const handleSubmit = async (data) => {
    const resultAction = await dispatch(SignIn(data));
    if (SignIn.fulfilled.match(resultAction)) {
      navigate(`${WHerToLogin ? WHerToLogin : "/manager/dashboard"}`);
    }
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 h-full gap-0">
      <img
        className="hidden lg:block h-screen w-full"
        src="/images/SuperGit-Accounts.jpeg"
        // src="https://res.cloudinary.com/domzl9omv/image/upload/v1763017408/doctors_save_time_g_seug7o.png"
      />
      <div className="flex items-center justify-center relative px-4 h-screen">
        <div
          className={`absolute top-4 ${
            i18n.language === "ar" ? "left-4" : "right-4"
          } flex items-center gap-3`}
        >
          <p className="bg-gradient py-1.5 px-3 text-white text-sm font-semibold rounded-full shadow-md">
            {t("SuperGitv2.1.4")} v{CurrentVersion}
          </p>
          <LangSwitcher />
        </div>
        <div className="w-full max-w-[600px] p-8">
          <div className="flex flex-col items-center justify-center mb-6">
            <img src="/images/supergit-03.png" className="w-28 lg:w-36" />
            <p className="font-semibold text-2xl lg:text-3xl text-center my-3">
              {t("LoginToYourAccount")}
            </p>
          </div>
          <LoginForm
            t={t}
            isLoading={isLoading}
            handleSubmit={handleSubmit}
            initialValues={initialValues}
            validationSchema={validationSchema}
          />
        </div>
      </div>
    </div>
  );
}

